const DICT = {
  AIRBAGS: "PODUSZKI POWIETRZNE",
  BRAKES: "HAMULCE",
  BUSHES: "TULEJE",
  DRIVELINE: "PRZENIESIENIE NAPĘDU",
  "SPRINGS AND SHOCKS": "SPRĘŻYNY, RESORY I AMORTYZATORY",
  STEERING: "UKŁAD KIEROWNICZY",
  "SUSPENSION KITS": "ZESTAWY ZAWIESZENIA",
  "SUSPENSION PARTS": "CZĘŚCI ZAWIESZENIA",
  OTHER: "INNE",
  Airbags: "Poduszki powietrzne",
  "Trakryder Extreme Kits": "Zestawy Trakryder Extreme",
  "Links/Brackets/Shackles": "Łączniki/uchwyty/wieszaki",
  "U-Bolts": "Strzemiona",
  "Control Arms": "Wahacze",
  "Front Spring Standard": "Przednie sprężyny standardowe",
  "Rear Spring Standard": "Tylne sprężyny standardowe",
  "Front Spring Raised": "Przednie sprężyny podnoszące",
  "Rear Spring Raised": "Tylne sprężyny podnoszące",
  "Front Spring Low": "Przednie sprężyny obniżające",
  "Rear Spring Low": "Tylne sprężyny obniżające",
  "Rear Shocks": "Tylne amortyzatory",
  "Front Shocks": "Przednie amortyzatory",
  "CV Shafts and Boots": "Półosie i osłony",
  "Rubber Bushes": "Tuleje gumowe",
  "Poly Bushes": "Tuleje poliuretanowe",
  "Brake Discs": "Tarcze hamulcowe",
  "Brake Pads": "Klocki hamulcowe",
  "Brake Shoes & Drums": "Szczęki i bębny hamulcowe",
  "Brake Conversion": "Konwersja hamulcowa",
  "Brake Accessories": "Akcesoria hamulcowe",
  "Big Brakes": "Duże hamulce",
  "Suspension Kits": "Zestawy zawieszenia",
  "Panhard Rods": "Drążki Panharda",
  "Chassis Parts": "Części podwozia",
  "Steering Dampers": "Amortyzatory skrętu",
  "Extreme Xa Coilovers": "Zawieszenia gwintowane",
  "Top Mounts": "Górne mocowania",
  "Accessories (S&S)": "Akcesoria (sprężyny i amortyzatory)",
  Bumpstops: "Odboje",
  Ezifits: "Kolumny Ezifit",
  "Camber Bolts": "Śruby regulujące kąt",
  "Hubs & Swivel Kits": "Piasty i zwrotnice",
  "Brake boosters": "Serwa hamulcowe",
  undefined: "Results",
};

export default DICT;
